<template>
    <div class="de-select-prop">
        <Select v-model="val" size="small" @on-change="change">
            <Option v-for="(item, index) in list" :value="`${item.label},${item.value},${item.percent}`" :key="index">{{ item.label }}</Option>
        </Select>
    </div>
</template>

<script>
export default {
    name: 'de-select-prop',
    props: {
        value: {
            type: Object
        },
        list: {
            type: Array
        }
    },
    watch: {
        value: {
            handler(v) {
                if (v) {
                    this.val = `${v.label},${v.value},${v.percent}`;
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            val: ''
        }
    },
    methods: {
        change(v) {
            if (v) {
                let param;
                let val = v.split(',');
                this.val = val[0];
                param = {
                    label: val[0], 
                    value: val[1], 
                };
                val[2] && (param['percent'] = val[2]);
                this.$emit('input', param);
                this.$emit('save');
            }
        }
    }
}
</script>

<style lang="less" scoped>
.de-select-prop {
    .right {
        float: right;
    }
}
</style>